module.exports = __webpack_public_path__ + "img/Bank.f9d15906.svg";